import * as S from './LoginBackground.style';

const LoginBackground = ({ children }: { children: React.ReactNode }) => {
  return (
    <S.BackgroundImageContainer>
      <S.RedisLogo />
      {children}
    </S.BackgroundImageContainer>
  );
};

export default LoginBackground;
